/* global IS_PROTOTYPE */

// import createLogger from 'vuex/dist/logger'

import { getAimeosPlugins } from '../modules/aimeos/plugins'
import { getAppPlugins } from '../modules/app/plugins'
import { vuexPersistence } from './persistence'
import messagesPlugins from '@/js/plugins/store/modules/messages/plugins.js'

// eslint-disable-next-line spaced-comment
////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////
//////////

export const getPlugins = () => {
  const plugins = []

  // eslint-disable-next-line spaced-comment
//////////////////////
/////////////////////
///////////////////////////////////////////////////////////
///
////////////////////////////////////////////
////////////

  plugins.push(...getAimeosPlugins())
  plugins.push(...getAppPlugins())
  plugins.push(vuexPersistence.plugin)
  plugins.push(...messagesPlugins)

  return plugins
}
